<template>
    <div />
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
    computed: {
        ...mapGetters({
            flowLoading: "flow/isLoading",
            orderId: "order/getOrderId"
        }),
        redirecturl() {
            return (
                window.location.origin +
                "/payment/" +
                `?provider=Free&reference=${encodeURIComponent(this.orderId)}`
            );
        }
    },
    watch: {
        // preventing race conditions from flow loading states
        flowLoading: function(isLoading, wasLoading) {
            if (!isLoading && wasLoading) {
                window.location = this.redirecturl;
            }
        }
    },
    mounted() {
        if (!this.flowLoading) {
            window.location = this.redirecturl;
        }
    },
    methods: {
        ...mapActions({
            gotoNextStep: "flow/gotoNextStep"
        })
    }
};
</script>
